import { atom, selector, selectorFamily, useRecoilValue } from 'recoil'
import { getRequest } from '/src/httpClient'
import { isBrowser } from '/src/util'

/*export const userState = atom({
  key: 'userState',
  default: null
})

export const userStateSelectorFamily = selectorFamily({
  key: 'userStateSelectorFamily',
  get: () => async () => {
    if (!isBrowser) return null
    return await getRequest('/api/user', new AbortController())
  }
})*/

export const userStateSelector = selector({
  key: 'userStateSelector',
  get: ({ get }) => {
    if (!isBrowser) return null
    return get(userState)
  }
})

const getUser = async () => {
  return await getRequest('/api/user', new AbortController())
}

export const userState = atom({
  key: 'userState',
  default: selector({
    key: 'userState/default',
    get: () => {
      if (!isBrowser) return []

      return getUser()
    }
  })
})

export const useUser = () => {
  return useRecoilValue(userState)
}
